import React from 'react'
import { observer } from 'mobx-react-lite'

const govCMSHome = process.env.REACT_APP_GOVCMS_HOME

const UnpaidWagesPossibleMatch = observer(() => {
  return (
    <>
      <h3>Possible match</h3>
      <p>We may be holding unpaid wages for this employee.</p>
      <p>
        To continue with their claim, the employee should{' '}
        <a href={govCMSHome + '/about-us/contact-us'}>Contact us</a>.
      </p>
    </>
  )
})

export default UnpaidWagesPossibleMatch
